import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStickyNote, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../../../../../../context';
import classNames from 'classnames';
import './styles.css';

const MappingCommentsIcon = (props) => {
    const { code, mapping, isUpdating } = props;
    const dispatch = useDispatch();

    let buttonIcon = faRedoAlt;
    if (!isUpdating) {
        buttonIcon = faStickyNote;
    }

    let classes = ['mr-2', 'mapping-comments', 'pop-hover'];
    if (!mapping?.comments || mapping?.comments === '') {
        classes.push('empty-mapping-comment');
    }

    const clickHandler = () => {
        dispatch(actions.daylight.setActionTargetCode(code));
        dispatch(actions.daylight.setActionTargetMapping(mapping));
        dispatch(actions.daylight.setMappingCommentModalOpen(true));
    };

    return (
        <FontAwesomeIcon
            icon={buttonIcon}
            className={classNames('mr-2 mapping-comments pop-hover', {
                rotating: isUpdating,
                'fa-disabled': isUpdating,
            })}
            title={getCommentsTitle(mapping?.comments)}
            onClick={() => clickHandler()}
            size="lg"
        />
    );
};

function getCommentsTitle(comments) {
    if (!comments || comments === '') return 'Add Comments';
    else if (comments.length < 400) return comments;
    else return comments.substring(0, 400) + '...';
}

export default MappingCommentsIcon;
